export const COUNTRY = `${process.env.REACT_APP_COUNTRY || 'kg'}`
